export default "__VITE_ASSET__CV6N6_V8__"